<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>Copyright © 2021 by Wayne State University Press, Detroit, Michigan, 48201. All rights reserved. No part of this book may be reproduced without formal permission. Manufactured in the United States of America.</p>
<p class="cipf">ISBN (paperback): 978-0-8143-4686-0</p>
<p class="cip">ISBN (hardcover): 978-0-8143-4685-3</p>
<p class="cip">ISBN (ebook): 978-0-8143-4687-7</p>
<p class="cipf">Library of Congress Control Number: 2021935718</p>
<p class="crtf">On cover: <i>Our Heavenly Mother</i>, illustration by Lindsay van Ekelenburg (<a class="url" href="http://www.lindsayvanek.com" target="_blank">www.lindsayvanek.com</a>). Cover design by Brad Norr.</p>
<p class="crtf">Wayne State University Press rests on Waawiyaataanong, also referred to as Detroit, the ancestral and contemporary homeland of the Three Fires Confederacy. These sovereign lands were granted by the Ojibwe, Odawa, Potawatomi, and Wyandot nations, in 1807, through the Treaty of Detroit. Wayne State University Press affirms Indigenous sovereignty and honors all tribes with a connection to Detroit. With our Native neighbors, the press works to advance educational equity and promote a better future for the earth and all people.</p>
<p class="crtf">Wayne State University Press</p>
<p class="crt">Leonard N. Simons Building</p>
<p class="crt">4809 Woodward Avenue</p>
<p class="crt">Detroit, Michigan 48201-1309</p>
<p class="crtf">Visit us online at <a class="url" href="http://www.wsupress.wayne.edu" target="_blank">wsupress.wayne.edu</a></p>
<p class="crtf">References to internet websites (URLs) were accurate at the time of writing. Neither the author nor Wayne State University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-midejewski-0005.vue?21f7c6d9